import React from 'react';
import { Box, Typography } from '@mui/material';
import FeedbackTable from '../../components/admin/FeedbackTable';
import DashboardContainer from '../../components/admin/DashboardContainer';

const FeedbackList = () => {
  return (
    <DashboardContainer title="Biblioteca">
      <Box mt={4}>
        <Typography variant="h5" mb={2}>
          Feedback
        </Typography>
        <FeedbackTable />
      </Box>
    </DashboardContainer>
  );
};

export default FeedbackList;